// extracted by mini-css-extract-plugin
module.exports = {"pulse":"styles_pulse__VuciV","jump":"styles_jump__fVqAq","wiggle":"styles_wiggle__ZTUxs"};